import usePhaserGame from '../../../hooks/usePhaserGame';
import PantallaCarga from './JuegoRuleta/PantallaCarga';
import JuegoRuleta from './JuegoRuleta/JuegoRuleta';

const PhaserRuleta = () => {
  const containerRef = usePhaserGame({
    scenes: [PantallaCarga, JuegoRuleta],
    width: 1000,
    height: 500,
  });

  return <div ref={containerRef} id="phaser-ruleta" />;
};

export default PhaserRuleta;
